import React, {useEffect, useState} from 'react';
import {Typography} from '@mui/material';
import {useParams} from 'react-router-dom';
import {useGodMode} from '../../components/Header/DebugModal';
import Loading from '../../components/Loading/Loading';

export const TestSetGroupPage: React.FC = () => {
  const {group} = useParams();
  const {onSetGroup} = useGodMode();
  const [done, setDone] = useState(false);
  useEffect(() => {
    onSetGroup(group as any).then(() => setDone(true));
  }, []);
  if (done) {
    return <Typography>Done</Typography>;
  }
  return <Loading entityName="god mode" />;
};
